:host {
  position: relative;
}

.lilu-tooltip {
  &-trigger,
  &-content-close {
    -webkit-appearance: none;
    border: 0;
    background-color: transparent;
    cursor: pointer;
  }

  &-trigger {
    position: relative;
    display: inline-block;
    z-index: 1;

    &.open {
      z-index: 2001;
    }
  }

  &-content {
    color: var(--color-nero);
    opacity: 0;
    left: 8px; //trigger width

    &-visible {
      &:after {
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        margin-left: -6px;
        bottom: -7.56px;
        left: 50%;
        border-style: solid;
        border-width: 4.46875px;
        border-color: var(--color-white);
        transform-origin: 0 0;
        -ms-transform-origin: 0 0;
        -webkit-transform-origin: 0 0;
        transform: rotate(-45deg) skew(-15deg, -15deg);
        -ms-transform: rotate(-45deg) skew(-15deg, -15deg);
        -webkit-transform: rotate(-45deg) skew(-15deg, -15deg);
      }
      &:before {
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        margin-left: -6px;
        bottom: -9.52px;
        left: 50%;
        border-style: solid;
        border-width: 5.45312px;
        border-color: var(--color-white) var(--color-gray-light);
        transform-origin: 0 0;
        -ms-transform-origin: 0 0;
        -webkit-transform-origin: 0 0;
        transform: rotate(-45deg) skew(-15deg, -15deg);
        -ms-transform: rotate(-45deg) skew(-15deg, -15deg);
        -webkit-transform: rotate(-45deg) skew(-15deg, -15deg);
        box-shadow: rgb(0 0 0 / 14%) 0 2px 4px 0;
        z-index: -1;
      }
    }
    &-right {
      &:after {
        left: 13px;
      }
      &:before {
        left: 13px;
      }
    }
    &-left {
      &:after {
        right: 7px;
        left: inherit;
      }
      &:before {
        right: 7px;
        left: inherit;
      }
    }
    font-family: var(--font-family-averta);
    display: none;
    width: 200px;
    font-size: 12px;
    background: var(--color-white);
    z-index: 0;
    position: absolute;
    bottom: calc(100% + 11px);
    text-align: center;
    line-height: 17px;
    border: 1px solid #d6d6d6;
    border-radius: 5px;
    box-shadow: rgb(0 0 0 / 14%) 0 2px 4px 0;
    transform: translateX(-50%);
    cursor: text;

    &-bottom.lilu-tooltip-content {
      transform: translateX(-50%) translateY(calc(100% + 3px));

      &:before,
      &:after {
        transform: rotate(135deg) skew(-15deg, -15deg);
      }
      &:after {
        margin-left: 4.48px;
        top: 1px;
      }
      &:before {
        margin-left: 5.42px;
        top: 0;
      }
    }

    &-left.lilu-tooltip-content {
      transform: none;
      right: -6px;

      &.lilu-tooltip-content-bottom {
        transform: translateY(calc(100% + 3px)) !important;
        &:before {
          margin-left: 0;
          right: -4px;
        }
        &:after {
          margin-left: 0;
          right: -2px;
        }
      }
    }

    &-right.lilu-tooltip-content {
      left: -6px;
      transform: none;
      margin-left: 0;

      &.lilu-tooltip-content-bottom {
        transform: translateY(calc(100% + 3px)) !important;
      }
    }

    &-inner {
      background-color: white;
      position: relative;
      padding: 19px 10px 10px;
      border-radius: 5px;
    }

    &-close {
      position: absolute;
      top: 3px;
      right: -2px;
      font-size: 12px;
    }
  }
}
